export default __webpack_public_path__ + "static/media/businessRegister.77fc96cd.png";